export * from './star-rating.module';
